var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 1.33325L13.3334 5.33325V13.3333C13.3334 13.6869 13.1929 14.026 12.9428 14.2761C12.6928 14.5261 12.3536 14.6666 12 14.6666H4.00002C3.6464 14.6666 3.30726 14.5261 3.05721 14.2761C2.80716 14.026 2.66669 13.6869 2.66669 13.3333V2.66659C2.66669 2.31296 2.80716 1.97382 3.05721 1.72378C3.30726 1.47373 3.6464 1.33325 4.00002 1.33325H9.33335ZM12 13.3333V5.99992H8.66669V2.66659H4.00002V13.3333H12ZM8.00002 12.6666L5.33335 9.99992H7.00002V7.99992H9.00002V9.99992H10.6667L8.00002 12.6666Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.2cd724b39c32beeaf61f178bdb12fe33.svg";
export { ForwardRef as ReactComponent };